if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			// static variable
			// static isVinValid = true;
			// static submissionCount = 0;
			// static prevTarget = null;

			constructor() {
				super();

				this.form = this.querySelector('form');
				this.form.querySelector('[name=id]').disabled = false;

				// CUSTOM: Add invalid event listener to form
				// this.form.addEventListener(
				// 	'invalid',
				// 	this.onValidationHandler.bind(this),
				// 	true
				// );

				// this.form.addEventListener('blur', this.onBlurHandler.bind(this), true);
				// this.form.addEventListener('input', this.onChangeHandler.bind(this));

				// exit button
				// this.form
				// 	.querySelector('.exit-btn')
				// 	?.addEventListener('click', (evt) => {
				// 		const input = evt.target.closest('.vin-input-card-wrapper');
				// 		if (input) {
				// 			input.style.display = 'none';
				// 			ProductForm.submissionCount = 0;
				// 			console.log('Count on Exit', ProductForm.submissionCount);

				// 			//Add to Cart Text change
				// 			this.submitButton.querySelector('span:first-child').textContent =
				// 				'Add to cart';
				// 		}
				// 	});

				// no vin checkbox checked
				// this.form
				// 	.querySelector('.no-vin-checkbox input')
				// 	?.addEventListener('change', (evt) => {
				// 		if (evt.target.checked) {
				// 			ProductForm.isVinValid = true;
				// 			evt.target.closest('.vin-input-card-wrapper').style.height =
				// 				'180%';
				// 			evt.target.closest('.vin-input-card-wrapper').style.top = '-220%';
				// 			this.form.querySelector('.vin-input-product-card').value = ' ';
				// 			this.form.querySelectorAll('.hide-on-checked').forEach((el) => {
				// 				el.style.display = 'none';
				// 			});
				// 		} else {
				// 			ProductForm.isVinValid = false;
				// 			evt.target.closest('.vin-input-card-wrapper').style.height =
				// 				'600%';
				// 			evt.target.closest('.vin-input-card-wrapper').style.top = '-600%';
				// 			this.form.querySelector('.vin-input-product-card').value = '';
				// 			this.form.querySelectorAll('.hide-on-checked').forEach((el) => {
				// 				el.style.display = 'block';
				// 			});
				// 		}
				// 	});

				// -----------------------------

				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

				this.cart =
					document.querySelector('cart-notification') ||
					document.querySelector('cart-drawer');
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector('cart-drawer'))
					this.submitButton.setAttribute('aria-haspopup', 'dialog');
			}

			// CUSTOM: handle invaild event
			// onValidationHandler(evt) {
			// 	// Condition would be based on event target
			// 	const input = evt.target.closest('.vin-input-card-wrapper');

			// 	if (input) {
			// 		input.style.display = 'block';
			// 	}
			// }

			// onBlurHandler(evt) {
			// 	const input = evt.target.closest('.vin-input-card-wrapper');
			// 	if (input) {
			// 		input.style.display = 'none';
			// 		ProductForm.submissionCount = 0;
			// 		console.log('Count on Blur', ProductForm.submissionCount);
			// 	}
			// }

			// onChangeHandler(evt) {
			// 	const wrapper = evt.target.closest('.vin-input-card-wrapper');
			// 	const inputCardMsg = wrapper.querySelector('.vin-card-msg');

			// 	inputCardMsg.innerHTML = '';

			// 	if (evt.target.value.length > 15 && evt.target.value.length < 18) {
			// 		this.vinDecode(evt.target.value).then((data) => {
			// 			const { year, make, model, engineSize, hasError, errorMsg } = data;

			// 			if (hasError) {
			// 				inputCardMsg.innerHTML = `Incorrect VIN number - Please check your VIN number or Add to cart without VIN. We will contact you later.`;
			// 				// ProductForm.isVinValid = false;
			// 				// this.form.querySelector('.no-vin-checkbox').style.display =
			// 				// 	'block';

			// 				//Add to Cart Text change
			// 				this.submitButton.querySelector('span:first-child').textContent =
			// 					'Continue without VIN';
			// 			} else {
			// 				inputCardMsg.innerHTML = `
			// 				<span class="data">${year}</span>
			// 				<span class="data">${make}</span>
			// 				<span class="data">${model}</span>
			// 				<span class="data">${engineSize}</span>
			// 				`;
			// 				// ProductForm.isVinValid = true;

			// 				// Hide no vin checkbox
			// 				// this.form.querySelector('.no-vin-checkbox').style.display =
			// 				// 	'none';

			// 				//Add to Cart Text change
			// 				this.submitButton.querySelector('span:first-child').textContent =
			// 					'Continue with VIN';
			// 			}
			// 		});
			// 	} else {
			// 		inputCardMsg.innerHTML = `Requires 17 characters.`;

			// 		//Add to Cart Text change
			// 		this.submitButton.querySelector('span:first-child').textContent =
			// 			'Continue without VIN';

			// 		// ProductForm.isVinValid = false;
			// 		// this.form.querySelector('.no-vin-checkbox').style.display = 'block';
			// 	}
			// }

			// async vinDecode(vinNum) {
			// 	try {
			// 		const trimmedVinNum = vinNum.trim();
			// 		const url = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVin/';
			// 		const res = await fetch(url + trimmedVinNum + '?format=json');
			// 		const data = await res.json();

			// 		const make = data.Results[7].Value;
			// 		const model = data.Results[9].Value;
			// 		const year = data.Results[10].Value;
			// 		const engineSize =
			// 			Number(data.Results[73].Value).toFixed(1).toString() + 'L';
			// 		const hasError = data.Results[1].Value === '0' ? false : true;
			// 		const errorMsg = data.Results[4].Value;

			// 		return { year, make, model, engineSize, hasError, errorMsg };
			// 	} catch (err) {
			// 		console.error(err);
			// 	}
			// }

			// -----------------------------

			onSubmitHandler(evt) {
				evt.preventDefault();

				// Change vin number to all uppercase
				// const vinNumOnProductPage = document.querySelector(
				// 	'input[name="properties[VIN-Number]"]'
				// );

				// if (vinNumOnProductPage && vinNumOnProductPage.value) {
				// 	// If it exists and has a value, convert the value to uppercase
				// 	vinNumOnProductPage.value = vinNumOnProductPage.value.toUpperCase();
				// 	console.log('vinNumOnProductPage', vinNumOnProductPage.value);
				// }

				if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

				this.handleErrorMessage();

				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				this.querySelector('.loading-overlay__spinner').classList.remove(
					'hidden',
				);

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData(this.form);

				// New FOR UPSELL
				// New: Check upsell option
				const selectedOption = document.querySelector(
					'input[name="ares-options"]:checked',
				)?.value;
				const upsellVariantId = document.querySelector(
					'input[name="ares-options"]:checked',
				)?.dataset.upsellVariantId;

				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map((section) => section.id),
					);
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}

				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector('.sold-out-message');
							if (!soldOutMessage) return;
							this.submitButton.setAttribute('aria-disabled', true);
							this.submitButton.querySelector('span').classList.add('hidden');
							soldOutMessage.classList.remove('hidden');
							this.error = true;
							return;
						} else if (!this.cart) {
							console.log('selectedOption', selectedOption);
							// Add logic to add upsell
							console.log('upselling');
							if (selectedOption === 'upsell' && upsellVariantId) {
								console.log('url', `${routes.cart_add_url}.js`);
								return fetch(`${routes.cart_add_url}.js`, {
									method: 'POST',
									headers: {
										'Content-Type': 'application/json',
										'X-Requested-With': 'XMLHttpRequest',
									},
									body: JSON.stringify({
										id: upsellVariantId,
										quantity: 1,
									}),
								})
									.then((upsellResponse) => upsellResponse.json())
									.then((data) => (window.location = window.routes.cart_url));
							}

							// Add logic to add upsell [end]
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
						this.error = false;
						const quickAddModal = this.closest('quick-add-modal');
						if (quickAddModal) {
							document.body.addEventListener(
								'modalClosed',
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true },
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove('loading');
						if (this.cart && this.cart.classList.contains('is-empty'))
							this.cart.classList.remove('is-empty');
						if (!this.error) this.submitButton.removeAttribute('aria-disabled');
						this.querySelector('.loading-overlay__spinner').classList.add(
							'hidden',
						);
					});
			}

			handleErrorMessage(errorMessage = false) {
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector('.product-form__error-message-wrapper');
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						'.product-form__error-message',
					);

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		},
	);
}
